<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="createCreditModal"
        persistent
        max-width="600px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">Add Credit</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeCreatCreditModal(), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                Credit added successfully
              </v-alert>
              <v-layout wrap>
                <!-- <v-flex
                  xs12
                  class="px-2"
                >
                  <branch-select v-model="addData.branch_id_fk" />
                </v-flex> -->

                <v-flex
                  xs12
                  class="px-2"
                >
                  <v-select
                    autocomplete
                    :items="customers"
                    v-model="addData.user_id_fk"
                    :error-messages="errors.collect('Customer')"
                    data-vv-name="Customer"
                    label="Customer*"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  xs6
                  class="px-2"
                >
                  <v-text-field
                    label="Amount USD*"
                    v-model.number="addData.amount"
                    :error-messages="errors.collect('amount')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="amount"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  class="px-2"
                >
                  <v-text-field
                    label="Amount IQD"
                    v-model="calculateIQDAmount"
                    data-vv-name="amount"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs12
                  class="px-2"
                >
                  <v-text-field
                    label="Note"
                    v-model="addData.note"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeCreatCreditModal(), $validator.reset(), resetForm()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="load"
                style="height:auto; margin-right: 3%"
                outline
                color="success"
              >Add</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'createCreditModal',
    'closeCreatCreditModal',
    'checkAlert',
    'addData',
    'createCredit',
    'customers',
    'currentExchangeRate',
    'load'
  ],

  data() {
    return {
      iqdAmount: null
    }
  },

  computed: {
    calculateIQDAmount: {
      get() {
        return this.formatNumber(this.iqdAmount)
      },
      set(value) {
        // Parse the input value to remove commas
        const parsedValue = this.parseNumber(value)
        this.iqdAmount = parsedValue
        // Calculate USD amount from IQD input
        if (this.currentExchangeRate && parsedValue) {
          this.addData.amount = parseFloat((parsedValue / this.currentExchangeRate).toFixed(2))
        }
      }
    }
  },

  methods: {
    formatNumber(value) {
      if (!value && value !== 0) return ''
      // Convert to integer for IQD by removing decimal part
      const numValue = parseFloat(value)
      const roundedValue = Math.round(numValue)
      return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    parseNumber(value) {
      if (!value) return 0
      // Remove thousand separators and convert to integer number for IQD
      const parsedValue = value.toString().replace(/,/g, '')
      return Math.round(parseFloat(parsedValue))
    },
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.createCredit()
          this.iqdAmount = null
        }
      })
    },
    resetForm() {
      this.iqdAmount = null
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user_credit/createCredit.vue